import { useState, useEffect } from 'react';
import { dsFetch } from '../utils/api';

const fmtAgo = (iso) => {
  if (!iso) return '';
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return 'agora';
  if (diff < 3600) return `${Math.floor(diff / 60)}min`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  return `${Math.floor(diff / 86400)}d`;
};

const fmtExp = (iso) => {
  if (!iso) return '—';
  const diff = (new Date(iso).getTime() - Date.now()) / 1000;
  if (diff < 0) return <span style={{ color: 'var(--accent-r)' }}>expirado</span>;
  if (diff < 3600) return `${Math.floor(diff / 60)}min`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  return `${Math.floor(diff / 86400)}d`;
};

export default function AdminUsers() {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('member');
  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [flash, setFlash] = useState(null); // { type, text, url }
  const [error, setError] = useState(null);

  const load = () => {
    dsFetch('/admin/invitations')
      .then(d => setInvites(d?.data?.invitations || []))
      .catch(e => setError(String(e.message || e)))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true); setError(null); setFlash(null);
    try {
      const d = await dsFetch('/admin/invitations', {
        method: 'POST',
        body: JSON.stringify({ email: email.trim(), role }),
      });
      const data = d?.data || {};
      setFlash({
        type: data.email_sent ? 'ok' : 'warn',
        text: data.email_sent
          ? `Convite enviado por email para ${email}`
          : `Convite criado mas email nao enviado${data.email_error ? ` (${data.email_error})` : ''}. Copie o link abaixo e envie manualmente:`,
        url: data.accept_url,
      });
      setEmail('');
      load();
    } catch (err) {
      setError(String(err.message || err));
    } finally {
      setSubmitting(false);
    }
  };

  const cancel = async (id) => {
    if (!confirm('Cancelar este convite?')) return;
    try {
      await dsFetch(`/admin/invitations/${id}`, { method: 'DELETE' });
      load();
    } catch (err) {
      alert(String(err.message || err));
    }
  };

  const copyLink = (url) => {
    navigator.clipboard.writeText(url).then(
      () => alert('Link copiado!'),
      () => prompt('Copie o link:', url),
    );
  };

  return (
    <div style={s.page}>
      <div style={s.topBar}>
        <div style={s.title}>Usuarios & Convites</div>
        <div style={s.subtitle}>Convide novos usuarios por email. Eles recebem um link pra criar a conta (definindo nome, telefone e senha).</div>
      </div>

      <form style={s.form} onSubmit={submit}>
        <input type="email" placeholder="email@dominio.com" value={email}
               onChange={e => setEmail(e.target.value)} style={s.input} required />
        <select value={role} onChange={e => setRole(e.target.value)} style={s.select}>
          <option value="member">Membro</option>
          <option value="admin">Admin</option>
        </select>
        <button type="submit" disabled={submitting} style={{ ...s.btn, opacity: submitting ? 0.5 : 1 }}>
          {submitting ? '...' : 'Enviar convite'}
        </button>
      </form>

      {error && <div style={s.errBox}>{error}</div>}

      {flash && (
        <div style={{ ...s.flashBox, borderColor: flash.type === 'ok' ? 'var(--accent-g)' : 'var(--accent-a)' }}>
          <div style={{ fontSize: 12, color: flash.type === 'ok' ? 'var(--accent-g)' : 'var(--accent-a)', fontWeight: 600 }}>{flash.text}</div>
          {flash.url && (
            <div style={{ marginTop: 8, display: 'flex', gap: 8, alignItems: 'center' }}>
              <input readOnly value={flash.url} style={{ ...s.input, flex: 1, fontFamily: 'monospace', fontSize: 11 }} />
              <button onClick={() => copyLink(flash.url)} style={s.btnGhost}>Copiar</button>
            </div>
          )}
        </div>
      )}

      <div style={s.section}>
        <div style={s.sectionTitle}>Convites pendentes ({invites.length})</div>
        {loading && <div style={s.dim}>Carregando...</div>}
        {!loading && invites.length === 0 && <div style={s.dim}>Nenhum convite pendente.</div>}
        {!loading && invites.length > 0 && (
          <table style={s.table}>
            <thead>
              <tr>
                <th style={s.th}>Email</th>
                <th style={s.th}>Role</th>
                <th style={s.th}>Convidado por</th>
                <th style={s.th}>Org</th>
                <th style={{ ...s.th, textAlign: 'right' }}>Criado</th>
                <th style={{ ...s.th, textAlign: 'right' }}>Expira em</th>
                <th style={{ ...s.th, textAlign: 'right', width: 100 }}>Acoes</th>
              </tr>
            </thead>
            <tbody>
              {invites.map(inv => (
                <tr key={inv.id} style={inv.expired ? { opacity: 0.5 } : {}}>
                  <td style={s.td}>{inv.email}</td>
                  <td style={s.td}>{inv.role}</td>
                  <td style={s.td}>{inv.inviter_name || '—'}</td>
                  <td style={s.td}>{inv.org_name || '—'}</td>
                  <td style={{ ...s.td, textAlign: 'right', color: 'var(--text3)' }}>{fmtAgo(inv.created_at)}</td>
                  <td style={{ ...s.td, textAlign: 'right' }}>{fmtExp(inv.expires_at)}</td>
                  <td style={{ ...s.td, textAlign: 'right' }}>
                    <button onClick={() => cancel(inv.id)} style={{ ...s.btnGhost, color: 'var(--accent-r)' }}>Cancelar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

const s = {
  page: { padding: 24, maxWidth: 1200, margin: '0 auto' },
  topBar: { marginBottom: 20 },
  title: { fontSize: 18, fontWeight: 700, color: 'var(--text)' },
  subtitle: { fontSize: 12, color: 'var(--text3)', marginTop: 4, maxWidth: 720 },
  form: { display: 'flex', gap: 8, marginBottom: 8 },
  input: { padding: '10px 14px', border: '1px solid var(--border)', borderRadius: 6, background: 'var(--surface2)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit', outline: 'none', flex: 1 },
  select: { padding: '10px 14px', border: '1px solid var(--border)', borderRadius: 6, background: 'var(--surface2)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit', cursor: 'pointer' },
  btn: { padding: '10px 22px', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' },
  btnGhost: { padding: '6px 12px', background: 'transparent', color: 'var(--text2)', border: '1px solid var(--border)', borderRadius: 4, fontSize: 11, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit' },
  errBox: { padding: '10px 14px', background: 'rgba(239,68,68,0.10)', color: 'var(--accent-r)', borderRadius: 6, fontSize: 12, marginBottom: 8 },
  flashBox: { padding: '12px 14px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 6, marginBottom: 12 },
  section: { marginTop: 24 },
  sectionTitle: { fontSize: 12, fontWeight: 600, color: 'var(--text2)', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 },
  dim: { fontSize: 12, color: 'var(--text3)', padding: 16 },
  table: { width: '100%', borderCollapse: 'collapse', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 6 },
  th: { textAlign: 'left', padding: '8px 12px', fontSize: 10, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 0.5, borderBottom: '1px solid var(--border)', fontWeight: 600 },
  td: { padding: '10px 12px', borderBottom: '1px solid var(--surface3)', fontSize: 12, color: 'var(--text)' },
};
